import {
  IonButton,
  IonCheckbox,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonLabel,
  IonList,
} from "@ionic/react";
import { mailOutline } from "ionicons/icons";
import React, { useState } from "react";

import config from "../../config.json";

export const Email = (props: { onFinish: (email: string) => void }) => {
  const [email, setEmail] = useState<string>("");
  const [checked, setChecked] = useState<boolean>(false);

  return (
    <IonList class="Email" lines="none">
      <IonItemDivider>Introduce tu email para ver el resultado</IonItemDivider>
      <IonItem className="Form">
        <IonIcon icon={mailOutline} />
        <IonInput
          placeholder="ejemplo@dominio.com"
          type="email"
          onIonChange={(e) => {
            let regex = new RegExp(
              "[A-Za-z0-9._%+-]{3,}@[a-zA-Z]{3,}([.]{1}[a-zA-Z]{2,}|[.]{1}[a-zA-Z]{2,}[.]{1}[a-zA-Z]{2,})"
            );
            if (e.detail.value && regex.exec(e.detail.value)) {
              setEmail(e.detail.value);
            } else {
              setEmail("");
            }
          }}
        ></IonInput>
        <IonButton
          disabled={!email || !checked}
          onClick={() => {
            props.onFinish(email);
          }}
        >
          Enviar
        </IonButton>
      </IonItem>
      <IonItem>
        <IonCheckbox
          checked={checked}
          onIonChange={(e) => setChecked(e.detail.checked)}
          color="success"
          style={{ marginLeft: "5px" }}
        />
        <IonLabel style={{ marginLeft: "5px" }}>
          He leido y acepto los términos y condiciones de Eneatest
        </IonLabel>
      </IonItem>
      <IonItem>
        <a target="_blank" href="/Condiciones">
          Ver términos y condiciones
        </a>
      </IonItem>
    </IonList>
  );
};
